import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer, StatusBox } from '../../Reusable'

import FadeIn from 'react-fade-in';
 
const { useHistory } = require('react-router-dom')

interface Props {
  title: string;
  type: 'discount' | 'event' | 'place';
  proId?: string;
  page?: number;

  onSelect: (item: any) => void;
  onCreate?: () => void;
}
const AdsList: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const user = useSelector(state => state.authReducer.user)
  const proId = props.proId
  const type = props.type

  const onFetch = async () => {
    try {
      let ref: any = Fire.store().collection('ads')
        .where('type', '==', type)
      if (proId) {
        ref = ref.where('proId', '==', proId)
      }
      ref = ref.orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)
      for (const item of list) {

        item.associated_to_col = item.pro && item.pro.name ? item.pro.name : 'Pop Out'
        item.created_by_col = item.creator && item.creator.name ? item.creator.name : item.pro && item.pro.name ? item.pro.name : 'Pop Out'

        item.total_orders_col = item.total_orders || 0
        item.impressions_col = item.impressions_count || 0
        item.views_col = item.views_count || 0
        if (type == 'event') {
          item.date_created_col = item.dateStart ? Fire.getDateFor(item.dateStart) : new Date()
          item.date_col = item.dateStart ? Time.moment(Fire.getDateFor(item.dateStart)).format('DD/MM/YYYY HH[h]mm') : '-'
        } else {
          item.date_created_col = item.createdAt ? Fire.getDateFor(item.createdAt) : new Date()
          item.date_col = item.createdAt ? Time.moment(Fire.getDateFor(item.createdAt)).format('DD/MM/YYYY HH[h]mm') : '-'
        }
      }
      return list
    } catch (err) {
      setError("Impossible de charger les annonces")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }

  const renderColumns = ({ refresh }) => {
    const cols: any[] = [
      { name: 'Image', accessor: 'image', cell: (item) => (
        <div className="table-preview">
          {item.pictures && item.pictures.length > 0 &&
            <img alt={item.name} src={item.pictures[0]} />
          }
        </div>
      ) },
      { name: 'Nom', string: 'name', sortable: true, accessor: 'name'},
      { name: 'Impressions', sortable: true, accessor: 'impressions_col' },
      { name: 'Clics', sortable: true, accessor: 'views_col' },
    ]

    if (type !== 'discount') {
      cols.push({ name: 'Nb. commandes', string: 'total_orders_col', sortable: true, accessor: 'total_orders_col' })
    }

    cols.push({
      name: 'Statut', accessor: 'status', cell: (item) => {
        const outOfDate = item.dateEnd ? Fire.getDateFor(item.dateEnd).getTime() < (new Date().getTime()) : false
        return (
          <StatusBox
            status={outOfDate ? 'Passé' : item.published ? 'Publié' : 'Caché'}
            type={outOfDate ? 'off' : item.published ? 'success': 'off'}
            />
        )
      }
    })
    
    if (user.admin) {
      cols.push({ name: 'Associé à', string: 'associated_to_col', sortable: true, accessor: 'associated_to_col'})
      cols.push({ name: 'Créé par', string: 'created_by_col', sortable: true, accessor: 'created_by_col'})
    }
    cols.push({ name: type === 'event' ? 'Date' : 'Créé le', date: 'date_created_col', sortable: true, accessor: 'date_col' })
    return cols
  }

  let createTitle = ''
  let searchTitle = ''
  switch (type) {
    case "event":
      searchTitle = 'Rechercher un évènement...'
      createTitle = 'Créer un évènement'
      break;
    case "discount":
      searchTitle = 'Rechercher un bon plan...'
      createTitle = 'Créer un bon plan'
      break;
    case "place":
      searchTitle = 'Rechercher un point de vente...'
      createTitle = 'Créer un point de vente'
      break;
    
    default:
      // code...
      break;
  }
  return (
    <ListContainer
      title={props.title}
      searchTitle={searchTitle}
      createTitle={createTitle}
      error={error}
      onFetch={onFetch}
      onCreate={props.onCreate}
      onSelect={props.onSelect}
      sorting={sorting}
      renderColumns={renderColumns}
      />
  );
}

export default AdsList